import {URAState} from 'src/lib/ura/reducers/uraReducers'
import {PfReduxState} from 'src/reducers/types'

export const uraIds = (state: PfReduxState): URAState['ura'] | undefined => state.lib.ura?.ura
